export default "__VITE_ASSET__8475a400__"